import React, { Fragment } from "react";
import blackBackground from "../../assets/pictures/old-black-background.jpg";
import { StateContext } from "../../containers/sidebarContext";
import CoverBoxes from "../CoverBoxes";
import { useTranslation } from "react-i18next";
import DrinkContains from "../DrinkContains/DrinkContains";

const RefreshingDrinks = (props) => {
  const state = React.useContext(StateContext);
  const { isSidebarOpen } = state;
  const { t } = useTranslation();

  const water = [
    { id: 1, title: "STILLES WASSER 0,25", price: "3.00" },
    { id: 2, title: "MINERAL WASSER 0,25", price: "3.00" },
  ];

  const sodas = [
    { id: 1, contain: "4,7,10", title: "COCA COLA 0,20", price: "3.50" },
    { id: 2, contain: "4,7,10", title: "COCA COLA ZERO 0,20", price: "3.50" },
    { id: 3, contain: "", title: "COCTA 0,275", price: "3.50" },
    { id: 4, contain: "3,4", title: "FANTA 0,20", price: "3.50" },
    { id: 5, contain: "1", title: "SPRITE 0,20", price: "3.50" },
    { id: 6, contain: "", title: "JANA 0,20", price: "3.50" },
    { id: 7, contain: "3,4", title: "ORANGINA ORANGE 0,25", price: "3.50" },
    { id: 8, contain: "3,4", title: "ORANGINA RED ORANGE 0,25", price: "3.50" },
    { id: 9, contain: "3,4", title: "ORANGENLIMONADA 0,33", price: "3.50" },
    { id: 10, contain: "8", title: "SCHWEPES GINGER 0,20", price: "3.50" },
    { id: 11, contain: "8", title: "SCHWEPES TONIC 0,20", price: "3.50" },
    { id: 12, contain: "8", title: "SCHWEPES BITTER 0,20", price: "3.50" },
  ];

  const juices = [
    { id: 1, contain: "3,4", title: "CEDEVITA", price: "3.00" },
    { id: 2, contain: "", title: "RAPS APPLE 0,20", price: "3.50" },
    { id: 3, contain: "", title: "RAPS ORANGE 0,20", price: "3.50" },
    { id: 4, contain: "", title: "FRISCHER ORANGENSAFT", price: "4.50" },
  ];

  const energyDrinks = [
    { id: 1, contain: "7,9", title: "RED BULL 0,25", price: "4.50" },
  ];

  return (
    <Fragment>
      {isSidebarOpen && (
        <>
          <div
            style={{
              backgroundImage: `url(${blackBackground})`,
              backgroundSize: "cover",
            }}
            className="content refreshing-drinks__box"
          >
            <div className="table__header">
              {" "}
              <h2>{t("refreshing_drinks:water")}</h2>
            </div>
            <table className="table table-borderless">
              <tbody>
                {water.map((item) => (
                  <tr key={item.id}>
                    <td>{item.title}</td>
                    <td>{item.price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="table__header">
              {" "}
              <h2>{t("refreshing_drinks:sodas")}</h2>
            </div>
            <table className="table table-borderless">
              <tbody>
                {sodas.map((item) => (
                  <tr key={item.id}>
                    <td>
                      <sup>{item.contain}</sup> <span>{item.title}</span>
                    </td>
                    <td>{item.price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="table__header">
              {" "}
              <h2>{t("refreshing_drinks:juices")}</h2>
            </div>
            <table className="table table-borderless">
              <tbody>
                {juices.map((item) => (
                  <tr key={item.id}>
                    <td>
                      <sup>{item.contain}</sup> <span>{item.title}</span>
                    </td>
                    <td>{item.price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="table__header">
              {" "}
              <h2>{t("refreshing_drinks:energy_drinks")}</h2>
            </div>
            <table className="table table-borderless">
              <tbody>
                {energyDrinks.map((item) => (
                  <tr key={item.id}>
                    <td>
                      <sup>{item.contain}</sup> <span>{item.title}</span>
                    </td>
                    <td>{item.price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <DrinkContains />
          </div>
          <CoverBoxes />
        </>
      )}
    </Fragment>
  );
};

export default RefreshingDrinks;
